/**
 * API endpoint paths for ShiftHub API
 * These match the Swagger documentation at http://localhost:7102/swagger
 */
export const ENDPOINTS = {

    // User endpoints 
    GET_CURRENT_USER_PROFILE: '/user/me',           // GET /api/User/profile (current user)
    GET_USER_PROFILE: '/user/search',               // GET /api/User/profile/{userId} (search by ID)
    UPDATE_USER_PROFILE: '/User/profile',           // PUT /api/User/profile/{workdayId}
    CREATE_NEW_USER: '/User/register',              // POST /api/User/register'
    REGISTER_ADMIN: '/User/register-admin',         // POST /api/User/register-admin
    ACTIVATE_USER: '/User/activate',                // POST /api/User/activate
    VALIDATE_USER: '/User/validate',                // GET /api/User/validate (for resgistration)
    CHECK_SUPER_USER: '/User/check-super-user',     // GET /api/User/check-super-user
    LOGIN: '/User/login',                           // POST /api/User/login
    FORGOT_PASSWORD: '/User/forgot-password',       // POST /api/User/forgot-password
    RESET_PASSWORD: '/User/reset-password',         // POST /api/User/reset-password
    RESET_TOKEN_INFO: '/User/reset-token-info',     // GET  /api/User/reset-token-info?token=...
    SWITCH_SITE: '/User/switch-site',               // POST /api/User/switch-site


    // Shift endpoints
    CREATE_SHIFT_REQUEST: '/shift/createShift',     // POST /api/Shift/createShift
    GET_SITE_DETAILS: '/shift/siteDetails',         // GET /api/Shift/siteDetails/{siteCd}
    GET_SHIFT_TIME: '/shift/shiftTime',             // GET /api/Shift/shiftTime/{siteCd}
    GET_SHIFT_TIME_OPTIONS: '/shift/shiftTimeOptions', // GET /api/Shift/shiftTimeOptions/{siteCd}
    GET_AVAILABLE_SHIFTS: '/shift/availableShifts', // GET /api/shift/availableShifts/{siteCd}?filter=all|thisweek|today
    GET_PENDING_SHIFTS: '/shift/pendingShifts',     // GET /api/shift/pendingShifts/{siteCd}?filter=all|thisweek|today
    GET_MY_SHIFTS: '/shift/myShifts',               // GET /api/shift/myShifts/{siteCd}/{userId}?filter=all|thisweek|today|range&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
    GRAB_SHIFT: '/shift/grabShift',                 // POST /api/shift/grabShift
    APPROVE_SHIFT: '/shift/approveShift',           // POST /api/shift/approveShift
    REJECT_SHIFT: '/shift/rejectShift',             // POST /api/shift/rejectShift
    GET_SUPERVISORS: '/shift/getSupervisors',       // GET /api/shift/getSupervisors/{siteCd}

    // GigShift settings endpoints
    SUBMIT_CUTOFF_TIME: '/gig/submitCutoffTime',        // POST /api/gig/submitCutoffTime
    GET_CUTOFF_TIME:    '/gig/cutoffTime',              // GET  /api/gig/cutoffTime/{siteCd}    

    // Report endpoints
    GET_KPI_REPORT: '/reports/kpi',                 // GET /api/reports/kpi?siteCd=XX&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
    GET_CALENDAR_REPORT: '/reports/calendar',       // GET api/reports/calendar?siteCd=NY01&startDate=2026-05-01&endDate=2026-05-31
    GET_TABLE_REPORT: '/reports/table',             // GET /api/reports/table/{siteCd}?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD&statusFilter=ALL|PST|PND|APP|DEN
    GET_DASHBOARD_REPORT: '/reports/dashboard',     // GET /api/reports/dashboard?siteCd=XX&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
    GET_WORKDAY_SYNC_REPORT: '/reports/workday-sync', // GET /api/reports/workday-sync?siteCd=XX&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
    GET_PROFILE_ADMIN_SUMMARY: '/reports/profile-admin-summary', // GET /api/reports/profile-admin-summary?siteCd=XX
    GET_GIG_REPORT: '/reports/gig',                 // GET /api/reports/gig?siteCd=XX&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD

    // Lookup value endpoints
    GET_SKILLS: '/lookupvalue/skills',              // GET: api/lookupvalue/skills/{siteCd}
    GET_TEAMS: '/lookupvalue/teams',                // GET: api/lookupvalue/teams
    GET_SITES: '/lookupvalue/sites',                // GET: api/lookupvalue/sites
    GET_ELIGIBILITY: '/lookupvalue/eligibility',    // GET /api/lookupvalue/eligibility/{siteCd}

    // Gig worker endpoints
    GIG_REQUEST_SHIFT: '/gig/requestShift',         // POST /api/gig/requestShift
    GIG_GET_REQUESTS: '/gig/requests',              // GET  /api/gig/requests?siteCd=XX&userId=XX&statusFilter=ALL
    GIG_UPDATE: '/gig/update',                      // PUT  /api/gig/update
    GIG_CANCEL: '/gig/cancel',                      // POST /api/gig/cancel
    GIG_MY_REQUESTS: '/gig/myRequests',             // GET  /api/gig/myRequests/{userId}?filter=all|today|thisweek
    GIG_POST_UNFILLED: '/gig/postUnfilled',         // POST /api/gig/postUnfilled/{siteCd}
    GIG_CALENDAR: '/gig/calendar',                  // GET  /api/gig/calendar/{siteCd}?filter=all|today|thisweek

} as const;

// Type for endpoint keys
export type EndpointKey = keyof typeof ENDPOINTS;